<div class="require-datasource">
    <div class="require-datasource__card">
        <span class="require-datasource__icon">
            <mat-icon aria-hidden="true">storage</mat-icon>
        </span>
        <p class="require-datasource__heading">Add a data source first</p>
        <p class="require-datasource__description">{{ cardDescription }}</p>
        <div class="require-datasource__actions">
            <button type="button" class="require-datasource__btn require-datasource__btn--primary"
                (click)="onSelectDataSource()">
                <mat-icon aria-hidden="true">add</mat-icon>
                <span>Select data source</span>
            </button>
            <button type="button" class="require-datasource__btn require-datasource__btn--secondary"
                (click)="onCancel()">
                Cancel
            </button>
        </div>
    </div>
</div>
